import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useAuthStore } from "@/stores/authStore";
import { useSocket } from "@/hooks/useSocket";
import { api } from "@/api/client";
export function DashboardPage() {
    const { activeChannel: channel } = useAuthStore();
    const { on } = useSocket();
    const [botStatus, setBotStatus] = useState(null);
    const [chatMessages, setChatMessages] = useState([]);
    useEffect(() => {
        api.get("/bot/status").then((res) => {
            if (res.data)
                setBotStatus(res.data);
        });
    }, []);
    useEffect(() => {
        const unsub = on("chat:message", (msg) => {
            setChatMessages((prev) => [...prev.slice(-99), msg]);
        });
        const unsubStatus = on("bot:status", (status) => {
            setBotStatus((prev) => prev ? { ...prev, ...status } : null);
        });
        return () => { unsub(); unsubStatus(); };
    }, [on]);
    const handleJoin = async () => {
        if (!channel)
            return;
        await api.post(`/channels/${channel.id}/join`);
        api.get("/bot/status").then((res) => {
            if (res.data)
                setBotStatus(res.data);
        });
    };
    const handleLeave = async () => {
        if (!channel)
            return;
        await api.post(`/channels/${channel.id}/leave`);
        api.get("/bot/status").then((res) => {
            if (res.data)
                setBotStatus(res.data);
        });
    };
    return (_jsxs("div", { className: "space-y-6", children: [_jsx("h1", { className: "text-2xl font-semibold", children: "Start" }), _jsxs("div", { className: "grid gap-4 md:grid-cols-3", children: [_jsxs(Card, { children: [_jsx(CardHeader, { className: "pb-2", children: _jsx(CardTitle, { className: "text-sm font-medium text-muted-foreground", children: "Bot Status" }) }), _jsx(CardContent, { children: _jsx(Badge, { variant: botStatus?.connected ? "default" : "destructive", children: botStatus?.connected ? "Connected" : "Disconnected" }) })] }), _jsxs(Card, { children: [_jsx(CardHeader, { className: "pb-2", children: _jsx(CardTitle, { className: "text-sm font-medium text-muted-foreground", children: "Channel" }) }), _jsxs(CardContent, { children: [_jsx("p", { className: "text-lg font-semibold", children: channel?.displayName ?? "None" }), _jsx("div", { className: "mt-2 flex gap-2", children: channel?.botJoined ? (_jsx(Button, { size: "sm", variant: "outline", onClick: handleLeave, children: "Leave" })) : (_jsx(Button, { size: "sm", onClick: handleJoin, children: "Join Channel" })) })] })] }), _jsxs(Card, { children: [_jsx(CardHeader, { className: "pb-2", children: _jsx(CardTitle, { className: "text-sm font-medium text-muted-foreground", children: "Uptime" }) }), _jsx(CardContent, { children: _jsx("p", { className: "text-lg font-semibold", children: botStatus ? `${Math.floor(botStatus.uptime / 3600)}h ${Math.floor((botStatus.uptime % 3600) / 60)}m` : "-" }) })] })] }), _jsxs(Card, { children: [_jsx(CardHeader, { children: _jsx(CardTitle, { children: "Live Chat" }) }), _jsx(CardContent, { children: _jsxs("div", { className: "h-80 overflow-y-auto space-y-1 font-mono text-sm bg-muted/50 rounded-md p-3", children: [chatMessages.length === 0 && (_jsx("p", { className: "text-muted-foreground", children: "No messages yet..." })), chatMessages.map((msg, i) => (_jsxs("div", { children: [_jsx("span", { style: { color: msg.color || "#9147ff" }, className: "font-semibold", children: msg.user }), _jsx("span", { className: "text-muted-foreground", children: ": " }), _jsx("span", { children: msg.message })] }, i)))] }) })] })] }));
}
